import { OrderType } from '../../providers/request/order-type.enum';
import { SearchRequest } from '../../providers/request/search-request.model';
import { ProjectFormExecuteType } from '../form/project-form-execute-type.enum';
import { RecordSource } from '../material/record-source.enum';
import { ArchiveFileSource } from './archive-file-source.enum';
import { ArchiveFileStatus } from './archive-file-status.enum';
export class ArchiveFileSearchRequest extends SearchRequest {
  fileId?: string;
  fileName?: string;
  fileTitle?: string;
  fileType?: number;
  fileSize?: number;
  filePageCount?: number;
  fileSignType?: number;
  filePath?: string;
  fileMd5?: string;
  fileAuthor?: string;
  fileStatus?: ArchiveFileStatus;
  projectId?: number;
  sectionId?: number;
  superiseSectionId?: number;
  sectionNames?: string;
  superiseSectionNames?: string;
  sectionItemId?: number;
  sectionItemFullCode?: string;
  sectionItemIds?: Array<number>;
  catalogId?: number;
  volumeId?: number;
  volumeIds?: Array<number>;
  fileSource?: ArchiveFileSource;
  recordSource?: RecordSource;
  workReportId?: number;
  workFlowId?: number;
  materialInspectionId?: number;
  materialTypeId?: number;
  materialModelId?: number;
  materialYear?: string;
  materialTypeNames?: string;
  materialModelNames?: string;
  materialBatchNos?: string;
  materialSelfReportSns?: string;
  materialSpotReportSns?: string;
  materialQaSns?: string;
  standardTestId?: number;
  standardTestType?: string;
  standardTestSelfReportSn?: string;
  standardTestSpotReportSn?: string;
  submitDate?: number;
  finishDate?: number;
  formSn?: string;
  formCode?: string;
  formName?: string;
  codeName?: string;
  formCopiesOrder?: number;
  formCatalog?: string;
  formCatalogOrder?: number;
  groupOrder?: number;
  formOrder?: number;
  formExecuteType?: ProjectFormExecuteType;
  publishUserId?: number;
  publishUserName?: string;
  publishOrgName?: string;
  publishSectionId?: number;
  formCategory?: string;
  constructionOrgName?: string;
  supervisionOrgName?: string;
  extFieldStr?: string;
  comment?: string;
  formSnOrder?: OrderType;
  formNameOrder?: OrderType;
  formCodeOrder?: OrderType;
  codeNameOrder?: OrderType;
  submitDateOrder?: OrderType;
  finishDateOrder?: OrderType;
  fileStatusOrder?: OrderType;
  volumeSortOrderOrder?: OrderType;
  volumeFileSortOrderOrder?: OrderType;
  materialBatchNosOrder?: OrderType;

  volumeSortOrder?: number;
}
